import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import Company from './Company';
import URLField from './URLField';

export default class SimpleCaseStudy extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get codename() {
    return this.system.codename;
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get photo() {
    return get(this, '_zdjecie.value[0]', {});
  }

  get publicationDate() {
    return get(this, '_data_publikacji.value', '');
  }

  get link() {
    const link = get(this, '_link_do_artykulu.value');
    return new URLField(link);
  }

  get company() {
    return get(this, '_spolka.value[0]', new Company());
  }
}



// WEBPACK FOOTER //
// ./src/models/SimpleCaseStudy.model.js